
import { useState, useEffect, useCallback } from 'react';
import { Customer } from '../../components/customer-selector/types';
import { supabase } from '@/lib/supabase/client';

export const useCustomerSelection = (
  customerId: string,
  setCustomerId: (id: string) => void,
  setCustomerName: (name: string) => void,
  setCustomerPhone: (phone: string) => void,
  setCustomerEmail: (email: string) => void,
  setCustomerCountry: (country: string) => void,
  setCustomerRegion: (region: string) => void,
  setCustomerMunicipality: (municipality: string) => void,
  setShippingAddress: (address: string) => void,
  setSelectedCustomer: (customer: Customer | null) => void
) => {
  // Handle customer selection
  const handleSelectCustomer = useCallback((id: string, name: string) => {
    console.log('Customer selected:', id, name);
    setCustomerId(id);
    setCustomerName(name);
    
    // Fetch customer details to get phone and other info
    if (id) {
      const fetchCustomerDetails = async () => {
        try {
          const { data: customer, error } = await supabase
            .from('customers')
            .select('*')
            .eq('id', id)
            .single();
            
          if (error) {
            console.error('Error fetching customer details:', error);
            return;
          }
          
          if (customer) {
            console.log('Customer details loaded:', customer);
            setSelectedCustomer(customer);
            setCustomerPhone(customer.phone || '');
            setCustomerEmail(customer.email || '');
            
            // Ensure we have default values for location fields
            const country = customer.country || 'Algeria';
            const region = customer.region || '';
            const municipality = customer.municipality || '';
            
            // Log the location values to debug
            console.log('Setting location fields:', {
              country,
              region,
              municipality,
              address: customer.address || ''
            });
            
            // Set the location values
            setCustomerCountry(country);
            setCustomerRegion(region);
            setCustomerMunicipality(municipality);
            setShippingAddress(customer.address || '');
          }
        } catch (err) {
          console.error('Error in fetchCustomerDetails:', err);
        }
      };
      
      fetchCustomerDetails();
    } else {
      // Reset customer data if no customer is selected
      setSelectedCustomer(null);
      setCustomerPhone('');
      setCustomerEmail('');
      setCustomerCountry('Algeria');
      setCustomerRegion('');
      setCustomerMunicipality('');
      setShippingAddress('');
    }
  }, [setCustomerId, setCustomerName, setSelectedCustomer, setCustomerPhone, setCustomerEmail, 
      setCustomerCountry, setCustomerRegion, setCustomerMunicipality, setShippingAddress]);

  // Log customer data changes
  useEffect(() => {
    if (customerId) {
      console.log('Customer ID updated:', customerId);
    }
  }, [customerId]);

  return { handleSelectCustomer };
};
